/*
 *  (c) 2015 - 2024 ENISCO by FORCAM GmbH
 */

import {TextField} from '@mui/material'
import React, {SyntheticEvent} from 'react'
import {useUserName} from '@enisco/mcc-react-lib'
import {defineMessage, FormattedMessage, MessageDescriptor, useIntl} from 'react-intl'
import useProfile from '../../../../hooks/useProfile'
import Autocomplete from '@mui/material/Autocomplete'
import {QuickLaunchType} from '../../../../model/quickLaunch'
import useQuickLaunchType from '../../../../hooks/useQuickLaunchType'

interface QuickLaunchOption {
  name: QuickLaunchType
  description: MessageDescriptor
}

const options : QuickLaunchOption[] = [
  {name: 'left', description: defineMessage({id:'QuickLaunchConfiguration.Left', defaultMessage: 'Left'})},
  {name: 'right', description: defineMessage({id:'QuickLaunchConfiguration.Right', defaultMessage: 'Right'})},
  {name: 'none', description: defineMessage({id:'QuickLaunchConfiguration.None', defaultMessage: 'None'})},
]

const QuickLaunchConfiguration: React.FC = () => {
  const [quickLaunchType] = useQuickLaunchType()
  const currentOption = options.find((o) => o.name === quickLaunchType) ?? 'left'
  const [, setProfile] = useProfile()
  const userName = useUserName()
  const intl = useIntl()

  const onChange = (e: SyntheticEvent, value: QuickLaunchOption | null) => {
    const newQuickLaunchType = value?.name ?? 'left'
    if (userName) {
      setProfile({quickLaunchType: newQuickLaunchType})
    }
  }

  return (
    <Autocomplete
      disabled={userName === undefined}
      sx={{width: '284px', marginTop: 2}}
      value={currentOption as QuickLaunchOption}
      onChange={onChange}
      id='change-quickLaunchBarType'
      getOptionLabel={(option) =>
        intl.formatMessage(option.description)
      }
      disableClearable={true}
      options={options}
      isOptionEqualToValue={(option, value) =>
        option.description === value.description
      }
      data-testid={'Apps:autocomplete'}
      renderInput={(params) => (
        <TextField
          {...params}
          label={
            <FormattedMessage
              id='MyProfileDialog.ShowQuickLaunchBar'
              defaultMessage='Show Quick launch bar'
            />
          }
          InputProps={{...params.InputProps}}
        />
      )}
    />
  )
}

export default QuickLaunchConfiguration
